module.exports = __webpack_public_path__ + "img/output_2.a95c1859.png";